import classNames from 'classnames';
import style from './ScrollBar.module.scss';
import { CSSProperties, ForwardedRef, forwardRef, ReactNode, UIEventHandler } from 'react';

export interface ScrollBarProps {
    hide?: boolean;
    maxHeight?: string | number;
    children: ReactNode;
    scrollComponentId?: string;
    autoHeight?: boolean;
    autoHeightMax?: number | string;
    height?: string | number;
    width?: number;
    className?: string;
    hidden?: boolean;
    onScroll?: UIEventHandler<HTMLDivElement>;
}

interface Props extends ScrollBarProps {}

/** @deprecated This component exists only for compatibility, just use the native scroll instead! */
export const ScrollBar = forwardRef(
    (
        {
            height,
            maxHeight,
            autoHeight,
            autoHeightMax = 200,
            hide,
            children,
            scrollComponentId,
            width,
            className,
            hidden,
            onScroll,
        }: Props,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        const styles: CSSProperties = {
            maxHeight: maxHeight
                ? typeof maxHeight === 'number'
                    ? `${maxHeight}px`
                    : maxHeight
                : autoHeight
                  ? autoHeightMax
                  : undefined,
            height: height ? (typeof height === 'number' ? `${height}px` : height) : autoHeight ? 'auto' : '100%',
            width: width,
        };

        return (
            <div
                style={styles}
                className={classNames([style.root, hide && style.hiddenScrollbars, hidden && style.hidden, className])}
                ref={forwardedRef}
                id={scrollComponentId}
                onScroll={onScroll}
            >
                {children}
            </div>
        );
    },
);
